import { useForm } from 'react-hook-form';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

//components
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';

//api
import { ProjectManagementService } from '../../service/projectmanagement-service';
import { PromptService } from '../../service/prompt-service';

const AddProject = ({onProjectCreated}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const [promptsData, setPromptsData] = useState({
    count: 0,
    next: null,
    previous: null,
    results: [],
  });
  const [selectedSystemPrompt, setSelectedSystemPrompt] = useState(null);
  const [selectedDefaultPrompt, setSelectedDefaultPrompt] = useState(null);

  //chiamata POST per creare un progetto
  const onSubmit = (data) => {
    const projectData = {
      ...data,
      system_prompt: selectedSystemPrompt ? selectedSystemPrompt.id : null,
      user_prompt: selectedDefaultPrompt ? selectedDefaultPrompt.id : null,
    };
    ProjectManagementService.createProject(projectData, (response) => {
      onProjectCreated()
      navigate('/dashboard/projects');
    });
  };

  //chiamata GET per recuperare i prompt
  useEffect(() => {
    const fetchPrompts = () => {
      PromptService.getAllPrompts(
        (data) => {
          if (data && Array.isArray(data.results)) {
            setPromptsData(data);
          } else {
            const errorMessage =
              'La risposta non contiene un array valido di prompt.';
            console.error(errorMessage);
          }
        },
        (error) => {
          console.error('Errore durante il recupero dei prompt: ', error);
        }
      );
    };
    fetchPrompts();
  }, []);

  const systemPrompts = promptsData.results.filter(
    (prompt) => prompt.is_system
  );
  const defaultPrompts = promptsData.results.filter(
    (prompt) => prompt.is_default
  );

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="addProject_Wrapper">
          <div className="addProject_InputWrapper">
            <label>Nome Progetto*</label>
            <InputText
              id="projectName"
              {...register('name', {
                required: 'Campo obbligatorio',
              })}
              className={errors.name ? 'p-invalid' : ''}
            />
            {errors.name && (
              <small className="p-error">{errors.name.message}</small>
            )}
          </div>

          <div className="addProject_InputWrapper">
            <label>Descrizione</label>
            <InputTextarea
              id="addProject_Input"
              {...register('notes')}
              rows={5}
              cols={30}
            />
          </div>
          <div>
            <div className="addProject__Dropdown">
              <label>Prompt di Sistema</label>
              <Dropdown
                value={selectedSystemPrompt}
                onChange={(e) => setSelectedSystemPrompt(e.value)}
                options={systemPrompts}
                optionLabel="name"
                placeholder="Seleziona un Prompt di Sistema"
                className="w-full md:w-14rem"
              />
            </div>
            <div className="addProject__Dropdown">
              <label>Prompt di Default</label>
              <Dropdown
                value={selectedDefaultPrompt}
                onChange={(e) => setSelectedDefaultPrompt(e.value)}
                options={defaultPrompts}
                optionLabel="name"
                placeholder="Seleziona un Prompt di Default"
                className="w-full md:w-14rem"
              />
            </div>
          </div>
          <Button type="Submit" className="addProject_SaveBtn">
            Salva
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AddProject;
